import React from "react";
import { CreditCard, FileText, PackageCheck } from "lucide-react";

const steps = [
  { n: "01", icon: CreditCard, title: "Pay.", body: "Pick $99.99 one-time or $175/mo. Pay securely. Done in 60 seconds." },
  { n: "02", icon: FileText, title: "Fill the form.", body: "2-minute intake. Tell us about your business, vibe, and what to feature." },
  { n: "03", icon: PackageCheck, title: "Receive content.", body: "We deliver your videos + images via Google Drive in 72–96 hours (depending on project size). Ready to post." },
];

export const HowItWorks = () => {
  return (
    <section className="py-20 md:py-28 relative" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="pill" data-testid="how-pill">How It Works</span>
            <h2 className="mt-5 font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter max-w-xl">
              Three steps. <span className="text-[#3B9EFF]">Zero headaches.</span>
            </h2>
          </div>
          <p className="text-[#A0AABF] max-w-md">
            No discovery calls. No 17-email back-and-forth. No 6-week timelines. Just content, delivered.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div key={i} className="snap-card relative" data-testid={`step-${i + 1}`}>
              <span className="font-accent text-xs text-[#3B9EFF]">STEP {s.n}</span>
              <div className="mt-4 w-12 h-12 rounded-md bg-[#3B9EFF]/10 border border-[#3B9EFF]/30 flex items-center justify-center text-[#3B9EFF]">
                <s.icon size={22} />
              </div>
              <h3 className="mt-5 font-display text-2xl font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-[#A0AABF] leading-relaxed">{s.body}</p>
              <div className="absolute top-6 right-6 font-display font-black text-5xl text-[#3B9EFF]/10">
                {s.n}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
